import React from 'react'
import { type AcademicUnitRowData } from '../types'
import { ButtonType } from '../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../store'
import { deleteAcademicUnitApi, getAcademicUnitList } from '../../../store/slices/academicUnitSlice/apis'
import { deleteLoading } from '../../../store/slices/academicUnitSlice/selectors'
import { grey } from '../../../colors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'
import type { ApiError } from '../../../models/Common'
import { notification } from '../../../components/Notifications'

interface DeleteAcademicUnitProps {
  selectedRow?: AcademicUnitRowData
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
}

const DeleteAcademicUnit: React.FC<DeleteAcademicUnitProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage }) => {
  const dispatch = useAppDispatch()
  const isDeleteLoading = deleteLoading()
  const theme = useTheme()

  const handleDelete = async (): Promise<void> => {
    try {
      await dispatch(deleteAcademicUnitApi({ urlId: selectedRow?.categoryId })).unwrap()
      handleCloseModal?.()
      await dispatch(getAcademicUnitList({})).unwrap()
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    }
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Academic Unit Category. All references to it will be deleted.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: isDeleteLoading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default DeleteAcademicUnit
